/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Clear_AllInputs */

const en_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear All`)
};

const fr_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer tout`)
};

const de_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles löschen`)
};

const it_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella tutto`)
};

const ru_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить все`)
};

const es_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todo`)
};

const zh_cn2_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部清除`)
};

const ja_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてクリア`)
};

const hi_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी साफ करें`)
};

const pt_pt2_subtitle_export_clear_all = /** @type {(inputs: Subtitle_Export_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar tudo`)
};

/**
* | output |
* | --- |
* | "Clear All" |
*
* @param {Subtitle_Export_Clear_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_clear_all = /** @type {((inputs?: Subtitle_Export_Clear_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Clear_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_clear_all(inputs)
	if (locale === "de") return de_subtitle_export_clear_all(inputs)
	if (locale === "it") return it_subtitle_export_clear_all(inputs)
	if (locale === "ru") return ru_subtitle_export_clear_all(inputs)
	if (locale === "es") return es_subtitle_export_clear_all(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_clear_all(inputs)
	if (locale === "ja") return ja_subtitle_export_clear_all(inputs)
	if (locale === "hi") return hi_subtitle_export_clear_all(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_clear_all(inputs)
	return en_subtitle_export_clear_all(inputs)
});